import { createContext, useContext, useEffect, useState, useCallback } from "react";

const LanguageContext = createContext(null);

const STORAGE_KEY = "fitswag_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === "it" || saved === "en") return saved;
    return "it";
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : "it")), []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
